import type { JobRunInput, JobRunKind } from "@/features/job/job-run/jobRun.types";
import { JobRunPullEstoreInventory } from "./JobRunPullEstoreInventory";

/** pullEstoreInventory in the run drawer. */
export const jobRunPullEstoreInventory: JobRunKind = {
  Settings: JobRunPullEstoreInventory,
  toInitialInput: (input) => {
    const initial: JobRunInput = {};
    const limit = ((input ?? {}) as JobRunInput).limit;
    if (typeof limit === "number") initial.limit = limit;
    return initial;
  },
  isComplete: () => true,
};
